import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || '';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API_BASE,
});

// Attach the signed bearer token from localStorage to every request. The
// server no longer trusts X-User-Id / X-User-Role — those are client-supplied
// and were forgeable. The token is HMAC-signed by the backend at login.
api.interceptors.request.use(
  (config) => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user && user.token) {
          if (!config.headers) {
            config.headers = {};
          }
          config.headers['Authorization'] = `Bearer ${user.token}`;
        }
      } catch (e) {
        console.error('Error parsing user from localStorage:', e);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// On 401, clear stale credentials and bounce the user back to /login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      try {
        localStorage.removeItem('user');
      } catch (e) {
        // ignore
      }
      if (typeof window !== 'undefined' && window.location && window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE };

